// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__32cY2","header":"PatientBlock_header__3KzL8","label":"PatientBlock_label__3YDIM","option":"PatientBlock_option__juXcm"};